import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn";
import {
    useForm,
    useFetch,
    useGrid,
    useResource,
    usePopup,
    useStore,
    useToast,
    useAuth,
    useModal,
    useTab,
    usePage,
} from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_SCHEMA_STSTCL_SELC,
    SG_STSTCL_SELC_TRDE,
    SG_GFS_CD_RPRT,
    SF_GFS_CD_RPRT,
} from "@/tz/go/egaz/osci/ststcl/lpco/service/OsciStstclSelcService";
import { MASK } from "@/tz/go/egaz/osci/lpco/comn/LpcoConstants";
/**
 * Report on collection by GFS Code Level II !== GFS 코드 2레벨의 징수 보고서 ==!
 */
export const OSCI0502010Q = (props: any) => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0004", "auth_osci0019"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    // 전체 조회용 기관(OGAZ0037)이면 OGA 선택 가능 !== ==!
    const isAllOga = auth.get("orgCd") === "OGAZ0037";

    const [srchPrdDvnCd, setSrchPrdDvnCd] = useState("Y");
    const [gfsCdRprt, setGfsCdRprt] = useState(comnUtils.getGridData([]));
    // ORG LIST
    const [orgCdList, setOrgCdList] = useState([]);

    let errmsg: any;

    /*
     * Definition Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Statistics by Search Form !== HSCODE 통계 검색 Form ==!
        gfsCdRprt: useForm({
            defaultSchema: SF_GFS_CD_RPRT,
            defaultValues: {
                ...(pgeStore?.form || {
                    srchPrdDvnCd: srchPrdDvnCd,
                    // 전체 조회용 기관(OGAZ0037)은 OGA를 공백으로 두어 전체 조회 !== ==!
                    orgCd: isAllOga ? "" : auth.get("orgCd"),
                    orgNm: isAllOga ? "" : auth.get("orgNm"),
                }),
            },
        }),
    };

    /*
     * Definition Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        gfsCdRprt: useGrid({
            defaultSchema: SG_GFS_CD_RPRT,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        /* LPCO Component List !== LPCO Component 목록 ==! */
        getGfsCdRprt: useFetch({
            api: (page = grid.gfsCdRprt.page) => {
                return APIS.getGfsCdRprt(form.gfsCdRprt.getValues(), page, grid.gfsCdRprt.size);
            },
            enabled: comnUtils.isEmpty(form.gfsCdRprt.errors) && form.gfsCdRprt.isSubmitted,
            key: [grid.gfsCdRprt.page, grid.gfsCdRprt.size],
            onSuccess: (data: any) => {
                setStore(pgeUid, {
                    form: form.gfsCdRprt.getValues(),
                    page: grid.gfsCdRprt.page,
                    size: grid.gfsCdRprt.size,
                });

                setGfsCdRprt(data?.gfsCdRprt || []);
                // if (srchPrdDvnCd == "Y") {
                //     grid.gfsCdRprt.setShow("column", "ststclYy", true);
                //     grid.gfsCdRprt.setShow("column", "ststclQrt", false);
                //     grid.gfsCdRprt.setShow("column", "ststclMm", false);
                // } else if (srchPrdDvnCd == "Q") {
                //     grid.gfsCdRprt.setShow("column", "ststclYy", true);
                //     grid.gfsCdRprt.setShow("column", "ststclQrt", true);
                //     grid.gfsCdRprt.setShow("column", "ststclMm", false);
                // } else if (srchPrdDvnCd == "M") {
                //     grid.gfsCdRprt.setShow("column", "ststclYy", true);
                //     grid.gfsCdRprt.setShow("column", "ststclQrt", false);
                //     grid.gfsCdRprt.setShow("column", "ststclMm", true);
                // } else if (srchPrdDvnCd == "C") {
                //     grid.gfsCdRprt.setShow("column", "ststclYy", false);
                //     grid.gfsCdRprt.setShow("column", "ststclQrt", false);
                //     grid.gfsCdRprt.setShow("column", "ststclMm", false);
                // }
            },
            onError: () => {},
            showToast: false,
        }),
        /* 통화별 집계(소계/총계) — 전체 데이터 기준 !== 통화별 집계 소계/총계 ==! */
        getGfsCdRprtSumm: useFetch({
            api: () => APIS.getGfsCdRprtSumm(form.gfsCdRprt.getValues()),
            // Fire with the list fetch, not only from the search button !== 목록과 같은 시점에 발화(검색 버튼 경유 외에도) ==!
            enabled: comnUtils.isEmpty(form.gfsCdRprt.errors) && form.gfsCdRprt.isSubmitted,
            onSuccess: (data: any) => {
                grid.gfsCdRprt.setSummary(Array.isArray(data) ? data : []);
            },
            onError: () => {},
            showToast: false,
        }),
    };

    const handler = {
        /* LPCO Component List !== LPCO Component 목록 ==! */
        getGfsCdRprt: () => {
            form.gfsCdRprt.handleSubmit(
                (data) => {
                    // Check before and after the date !== 날짜 앞뒤 체크 ==!
                    let startDt = "";
                    let endDt = "";
                    let focusName = "";
                    if (srchPrdDvnCd == "Y") {
                        startDt = form.gfsCdRprt.getValue("srchStrYear");
                        // endDt = form.gfsCdRprt.getValue("srchEndYear");

                        focusName = "srchEndYear";
                    } else if (srchPrdDvnCd == "Q") {
                        startDt = form.gfsCdRprt.getValue("srchStrQrtYy") + form.gfsCdRprt.getValue("srchStrQrt");
                        // endDt = form.gfsCdRprt.getValue("srchEndQrtYy") + form.gfsCdRprt.getValue("srchEndQrt");

                        focusName = "srchEndQrtYy";
                    } else if (srchPrdDvnCd == "M") {
                        startDt = form.gfsCdRprt.getValue("srchStrYmYy") + form.gfsCdRprt.getValue("srchStrYmMm");
                        // endDt = form.gfsCdRprt.getValue("srchEndYmYy") + form.gfsCdRprt.getValue("srchEndYmMm");

                        focusName = "srchEndYmYy";
                    } else if (srchPrdDvnCd == "C") {
                        startDt = form.gfsCdRprt.getValue("srchCustomStrtDt");
                        endDt = form.gfsCdRprt.getValue("srchCustomEndDt");

                        focusName = "srchCustomEndDt";
                    }
                    if (srchPrdDvnCd == "C" && endDt < startDt) {
                        modal.openModal({
                            content: "msg.osc.00081",
                        });
                        form.gfsCdRprt.setFocus(focusName);
                        return false;
                    }

                    grid.gfsCdRprt.setSummary(null);
                    grid.gfsCdRprt.setPage(0);
                    fetch.getGfsCdRprt.fetch(0);
                    fetch.getGfsCdRprtSumm.fetch();
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
        refreshOrgCdList: async () => {
            setOrgCdList((await lpcoUtils.getOrgCdList()) || []);
        },
        setInit: async () => {
            // !== 기관 목록 ==!
            handler.refreshOrgCdList();
        },
    };

    useEffect(() => {
        lpcoUtils.setSrchFormFromStore(form.gfsCdRprt, pgeStore);
        setSrchPrdDvnCd(form.gfsCdRprt.getValue("setSrchPrdDvnCd") || "Y");
        handler.setInit();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.gfsCdRprt.schema.orgCd} options={orgCdList} edit={isAllOga} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.gfsCdRprt.schema.srchCstmOfceCd} />
                            <Group.Control {...form.gfsCdRprt.schema.srchFeeCurrCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.gfsCdRprt.schema.srchPrdDvnCd}
                                onChange={(v: any) => {
                                    console.log("v ", v);
                                    setSrchPrdDvnCd(v);
                                }}
                            />
                        </Group.Row>
                        {srchPrdDvnCd == "Y" && (
                            <Group.Row>
                                <Group.Control {...form.gfsCdRprt.schema.srchStrYear} />
                                {/* <Group.Control {...form.gfsCdRprt.schema.srchEndYear} /> */}
                            </Group.Row>
                        )}
                        {srchPrdDvnCd == "Q" && (
                            <Group.Row>
                                <Group.Label label={"L_QRT"} required={true}></Group.Label>
                                <Group.Col>
                                    <FormControl {...form.gfsCdRprt.schema.srchStrQrtYy} />
                                    <Group.Any>-</Group.Any>
                                    <FormControl {...form.gfsCdRprt.schema.srchStrQrt} />
                                </Group.Col>
                                {/* <Group.Label label={"L_END_QRT"} required={true}></Group.Label>
                                <Group.Col>
                                    <FormControl {...form.gfsCdRprt.schema.srchEndQrtYy} />
                                    <Group.Any>-</Group.Any>
                                    <FormControl {...form.gfsCdRprt.schema.srchEndQrt} />
                                </Group.Col> */}
                            </Group.Row>
                        )}
                        {srchPrdDvnCd == "M" && (
                            <Group.Row>
                                <Group.Label label={"L_MM"} required={true}></Group.Label>
                                <Group.Col>
                                    <FormControl {...form.gfsCdRprt.schema.srchStrYmYy} />
                                    <Group.Any>-</Group.Any>
                                    <FormControl {...form.gfsCdRprt.schema.srchStrYmMm} />
                                </Group.Col>
                                {/* <Group.Label label={"L_END_YM"} required={true}></Group.Label>
                                <Group.Col>
                                    <FormControl {...form.gfsCdRprt.schema.srchEndYmYy} />
                                    <Group.Any>-</Group.Any>
                                    <FormControl {...form.gfsCdRprt.schema.srchEndYmMm} />
                                </Group.Col> */}
                            </Group.Row>
                        )}
                        {srchPrdDvnCd == "C" && (
                            <Group.Row>
                                <Group.Control {...form.gfsCdRprt.schema.srchCustomRnge} />
                            </Group.Row>
                        )}
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="reset"
                                onClick={() => {
                                    form.gfsCdRprt.reset();
                                    // 조회 기간 구분은 화면 상태로 하위 입력을 제어하므로 함께 초기화한다.
                                    setSrchPrdDvnCd("Y");
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={() => {
                                    handler.getGfsCdRprt();
                                }}
                            />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="excelDown"
                                onClick={async () => {
                                    const bResult = await form.gfsCdRprt.validate();
                                    if (bResult) {
                                        // excel download
                                        lpcoUtils.saveExcelDownload(
                                            BASE.api + "/gfs-cd-rprt/excel-down",
                                            form.gfsCdRprt.getValues(),
                                        );
                                    }
                                }}
                            />
                        </Layout.Left>
                    </Layout>

                    <Group.Section>
                        <Grid {...grid.gfsCdRprt.grid} data={gfsCdRprt} />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
